/** Max dimension for editor canvas scaling (brush/merge math). */
export const MAX_CANVAS_SIZE = 1200;

export const MODEL_PATH = '/models/model.onnx';

/** Track roomImageIds we've already run inference for (survives Strict Mode double-mount). */
export const aiInferenceDone = new Set();

/** Labels that are never grouped; each item stays its own row. Case-insensitive. */
export const UNGROUPED_LABELS = new Set(['wall', 'walls', 'floor', 'floors', 'ceiling', 'ceilings']);

/** Below this (0–1), UI warns about model uncertainty for detected interiors. */
export const LOW_CONFIDENCE_THRESHOLD = 0.3;

export const DRAFT_SCHEMA_VERSION = 1;
export const DRAFT_MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const DRAFT_AUTOSAVE_DELAY_MS = 1000;
